import RoleList from '@/pages/components/manage/sys/role/RoleList';

export default {
    list: RoleList,
    recordRepresentation: 'roleName',
};
